<template>
  <ComponentTypeNumber />
  <ComponentTypeText />
  <ComponentTypeSelect />
  <ComponentTypeToggle />
</template>

<script>
import ComponentTypeNumber from "./inputsTypes/ComponentTypeNumber.vue";
import ComponentTypeText from "./inputsTypes/ComponentTypeText.vue";
import ComponentTypeSelect from "./inputsTypes/ComponentTypeSelect.vue";
import ComponentTypeToggle from "./inputsTypes/ComponentTypeToggle.vue";

export default {
  components: {
    ComponentTypeNumber,
    ComponentTypeText,
    ComponentTypeSelect,
    ComponentTypeToggle,
  },
  setup() {
    return {};
  },
};
</script>

<style></style>
